<template>
  <div ref="refWrap" class="ms-timepicker ms-editor w-100" :class="[{'ms-validate': isValidate}]">
    <label v-if="label" class="label"
      >{{ label }}
      <span v-if="required">*</span>
    </label>
    <div
      ref="inputField"
      class="ms-container--timepicker flex-row"
      :class="[{error: errorMessage, disabled: disabled}, hasBorder ? 'border' : '']"
    >
      <input
        ref="input"
        class="ms-input--timepicker flex"
        :value="rawValue"
        :tabindex="0"
        :autofocus="autofocus"
        :disabled="disabled"
        :class="{disabled: disabled}"
        :readOnly="readOnly"
        v-on="listeners"
      />
      <div
        ref="icon"
        :class="['ms-clock', {disabled: disabled}, {'event-none': readOnly}]"
        v-on="clockButtonListeners"
      ></div>
      <div ref="msTimePicker" class="timepicker-content">
        <timepicker
          v-if="isShowToogle"
          ref="timepicker"
          v-model="valueTime"
          :screen-x="0"
          :screen-y="0"
          class="timepicker"
          @close="onCloseTimePicker"
          @hide.stop="onHide"
          @msMounted="childComponentMounted"
          :showSecond="showSecond"
          :step="step"
        ></timepicker>
      </div>
    </div>
    <div v-if="errorMessage" class="error-text">{{ errorMessage }}</div>
    <slot name="error"></slot>
  </div>
</template>

<script>
import IMask from 'imask';
import Timepicker from './TimePicker.vue';
import MsBaseComponent from '@/components/base/MsBaseComponent.vue';
import {useValidateControl} from '@/setup/validateControl.js';

export default {
  name: 'MsTimePicker',
  components: {
    Timepicker,
  },
  extends: MsBaseComponent,
  inject: {
    elForm: {
      default: '',
    },
    elFormItem: {
      default: '',
    },
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      required: false,
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
    },
    /**
     * Các rule phục vụ cho validate control
     */
    rules: {
      type: [Object, String],
      default: '',
    },
    typeInput: {
      default: null,
      type: String,
    },
    /**
     * Căn dropdown theo input box: right/left/center
     */
    alignX: {
      default: 'right',
      type: String,
    },
    showSecond: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  setup(props) {
    const {errorMessage, validate, isValidate, clearValidate} = useValidateControl({
      props,
    });
    return {errorMessage, validate, isValidate, clearValidate};
  },
  data: function () {
    return {
      rawValue: '',
      valueTime: this.modelValue ? this.modelValue : '',
      mask: {
        mask: this.showSecond ? 'H{:}M{:}S' : 'H{:}M',
        lazy: false,
        blocks: {
          H: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 23,
            maxLength: 2,
          },
          M: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 59,
            maxLength: 2,
          },
          S: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 59,
            maxLength: 2,
          },
        },
        overwrite: true,
        autofix: false,
      },
      isShowToogle: false,
      innerValue: this.value,
      isFocus: false,
      isWarning: false,
      hasWarning: false,
      screenX: '',
      screenY: '',
      heightEl: '',
      width: '',
      screenParentX: '',
      screenParentY: '',
      hoverx: false,
    };
  },
  computed: {
    required() {
      if (this.rules) {
        const required = this.rules.find(x => x.name === 'required');
        return required;
      }
    },
    listeners() {
      return {
        input: evt => {},
        focus: evt => {
          this.hoverx = false;
          this.hasWarning = false;
          this.isWarning = false;
          this.$emit('focus', evt);
          this.changeFocus(true);
        },
        mouseover: evt => {
          this.hoverx = true;
        },
        mouseout: evt => {
          this.hoverx = false;
        },
        blur: evt => {
          this.onBlur(evt);
        },
      };
    },
    clockButtonListeners() {
      return {
        click: () => {
          this.toggleClick();
        },
        mousedown: evt => {
          evt.preventDefault();
        },
      };
    },
    /**
     * Buid động validation rules theo config của control
     */
    validateRules() {
      const me = this;
      let rules = me.rules;

      if (!rules) {
        rules = '';
      }

      if (me.required) {
        rules = me.appendRuleValidation('required', rules);
      }
      return rules;
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        if (!newVal) {
          newVal = '';
        }
        me.setDefaultTime(newVal);
        me.setRawValue(newVal);
      },
    },
    valueTime: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        me.updateVModel(newVal);
        me.setRawValue(newVal);
      },
    },
  },

  mounted() {
    this.heightEl = this.$el.offsetHeight;
    this.width = this.$el.offsetWidth;
    this.initPicker();
  },

  methods: {
    getValue() {
      return this.rawValue;
    },
    setDefaultTime(val) {
      const me = this;
      me.valueTime = val;
    },
    setRawValue(val) {
      const me = this;
      if (val instanceof Date) {
        me.rawValue = `${val.getHours()}:${val.getMinutes()}:${val.getSeconds()}`;
      } else {
        me.rawValue = `${val}`;
      }
    },
    /**
     * Sự kiện chọn từ popup DatePicker
     */
    onCloseTimePicker(e) {
      const me = this;
      me.isShowToogle = false;
      const value = me.valueTime;
      me.updateVModel(value);
      me.$refs.input.focus();
    },
    updateVModel(val) {
      this.$emit('update:modelValue', val);
    },
    /**
     * Xử lý cập nhật vào v-model nếu đã hoàn thành việc nhập liệu
     */
    maskInputComplete() {
      const me = this;
      const momentMask = me.momentMask;
      const masked = momentMask ? momentMask.masked : null;
      me.updateVModel(masked.value);
      me.setRawValue(masked.value);
      me.validate();
    },
    maskInputAccept() {},
    initPicker() {
      const me = this;
      const element = me.$refs.input;
      const momentMask = IMask(element, me.mask);

      momentMask.on('complete', me.maskInputComplete);
      momentMask.on('accept', me.maskInputAccept);
      me.momentMask = momentMask;
    },
    toggleClick(e) {
      const me = this;
      if (me.disabled) {
        return;
      }
      me.isShowToogle = !me.isShowToogle;
    },
    onComplete(e) {
      this.innerValue = e.detail.unmaskedValue;
      e.detail.updateValue();
      this.$emit('input', this.innerValue);
    },
    onAccept() {},
    // animation
    onBlur: function (evt) {
      var me = this;

        if (!me.isShowToogle) {
          me.validate(me);
          me.setRawValue(me.modelValue, null);
          me.$emit('blur', evt);
        }
    },
    onHide() {
      const me = this;
      me.isShowToogle = false;
    },
    changeFocus(booleanx) {
      const me = this;
      me.isFocus = booleanx;
    },
    beforeEnter(el) {
      el.style.height = 0;
    },
    enter(el, done) {
      const h = el.scrollHeight;
      el.style.height = h + 'px';
      done();
    },
    leave: function (el) {
      el.style.height = 0 + 'px';
    },
    focusInput() {
      this.$refs.msinput.focus();
    },
    onMouseover(event) {
      if (this.isWarning) {
        this.hasWarning = true;

        this.screenX = event.screenX;
        this.screenY = event.screenY;
      }
    },
    onMouseout() {
      this.hasWarning = false;
    },
    updatePositionDropdownMenu() {
      const me = this;
      const rectDropdownMenu = me.$refs.msTimePicker.getBoundingClientRect();
      const rectInputField = me.$refs.inputField.getBoundingClientRect();
      const wInputField = rectInputField.width;
      const hInputField = rectInputField.height;
      const wWindow = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const hWindow = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const wDropdown = rectDropdownMenu.width ? rectDropdownMenu.width : 96;
      const hDropdown = rectDropdownMenu.height ? rectDropdownMenu.height : 96;
      switch (me.alignX) {
        case 'left':
          me.$refs.msTimePicker.style.left = '0px';
          break;
        case 'left':
          me.$refs.msTimePicker.style.right = '0px';
          break;
        case 'center':
          me.$refs.msTimePicker.style.left = (wInputField - wDropdown) / 2 + 'px';
          break;
        default:
          me.$refs.msTimePicker.style.right = '0px';
          break;
      }

      if (hWindow - rectInputField.y - hDropdown - hInputField - 5 > 0) {
        me.$refs.msTimePicker.style.bottom = `${-4 - hDropdown}px`;
      } else {
        me.$refs.msTimePicker.style.bottom = hInputField + 4 + 'px';
      }
    },
    childComponentMounted() {
      this.updatePositionDropdownMenu();
      this.validate();
    },
  },
};
</script>
<style></style>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsTimePicker.scss';

@media screen and (max-width: 1366px) {
  @import '@/assets/scss/components/MsInput.scss';
}

@media screen and (min-width: 1367px) {
  @import '@/assets/scss/components/MsInput.scss';
}
</style>
